<template>
    <div class="sustainable-component manage-workpositions">
        <div class="container-fluid p-0 mt-3">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div v-html="$t('workorganisation_tab2_tool_define_positions_text')"></div>
                    <v-form v-model="valid" ref="form">
                        <div>
                            <v-text-field v-bind:disabled="disabled" :rules="[rules.required]" bg-color="white" name="jobPositionName"
                                          data-testid="job-position-name-input"
                                          id="jobPositionName"
                                          v-bind:label="$t('general.workorganisation_general_name')"
                                          variant="outlined"
                                          v-model="jobPositionName">
                            </v-text-field>
                        </div>
                        <div>
                            <v-btn v-bind:disabled="disabled" data-testid="job-position-create-button" variant="tonal" class="bg-primary mb-3" @click="addJobPosition">
                                {{$t('workorganisation_tab2_create_position')}}
                            </v-btn>
                        </div>
                    </v-form>
                </div>
                <div class="col-12 col-md-6">

                    <table data-testid="job-position-list" class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th>Befattning</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in internalModel.JobPositions"
                                :key="index"
                                :data-testid="jobPositionRowTestId(item)"
                                :data-job-position-name="jobPositionDisplayName(item)">
                                <td class="col-6">
                                    <span>{{ jobPositionDisplayName(item) }}</span>
                                </td>
                                <td class="col-1">
                                    <div class="text-right" style="" v-if="disabled == false">
                                        <div class="dropdown text-right pr-2">
                                            <a href="#"
                                               class="drop"
                                               :data-testid="jobPositionMenuTriggerTestId(item)"
                                               data-bs-toggle="dropdown"
                                               aria-expanded="false">
                                                ...
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-right">
                                                <a href="javascript:void(0)"
                                                   :data-testid="jobPositionEditTestId(item)"
                                                   @click="modifyJobPosition(item)"
                                                   class="dropdown-item">Ändra</a>
                                                <a href="javascript:void(0)"
                                                   :data-testid="jobPositionDeleteTestId(item)"
                                                   @click="deleteJobPosition(jobPositionId(item))"
                                                   class="dropdown-item">Ta bort</a>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <UpdateWorkposition  v-bind:disabled="disabled" ref="workpositiondialog" @workpositionupdated="workPositionUpdated"></UpdateWorkposition>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>


<script>

    import ValidationService from "../../Services/ValidationService";
    import WorkOrganisationService from "../../Services/WorkOrganisationService";
    import UpdateWorkposition from "./update-workposition.vue";
    import CommonSpinner from '../../common/common-spinner.vue'
    import { ref } from 'vue'
    const form = ref(null);
    const workpositiondialog = ref(null);

    export default {

        name: 'manage-workpositions',
        emits: ['positionSelected', 'position-selected', 'jobPositionsChanged', 'job-positions-changed'],
        props: {
            model: Object,
            selectedJobPosition: [String, Number],
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components:{
            UpdateWorkposition,
            CommonSpinner,
        },
        methods: {
            jobPositionId(item) {
                if (!item) {
                    return null;
                }
                var id = item.JobPositionId !== undefined ? item.JobPositionId : item.jobPositionId;
                return id;
            },
            jobPositionDisplayName(item) {
                if (!item) {
                    return '';
                }
                var n = item.Name !== undefined ? item.Name : item.name;
                return n || '';
            },
            jobPositionRowTestId(item) {
                var id = this.jobPositionId(item);
                return id ? ('job-position-row-' + id) : null;
            },
            jobPositionMenuTriggerTestId(item) {
                var id = this.jobPositionId(item);
                return id ? ('job-position-menu-trigger-' + id) : null;
            },
            jobPositionEditTestId(item) {
                var id = this.jobPositionId(item);
                return id ? ('job-position-edit-' + id) : null;
            },
            jobPositionDeleteTestId(item) {
                var id = this.jobPositionId(item);
                return id ? ('job-position-delete-' + id) : null;
            },
            debugWorkOrganisationFlow(eventName, payload) {
                try {
                    var enabled = window.location.hostname === 'localhost'
                        || window.location.hostname === '127.0.0.1'
                        || window.localStorage.getItem('swc.workOrganisation.debug') === 'true';
                    if (!enabled) {
                        return;
                    }
                    console.debug('[SWC WorkOrganisation]', 'manage-workpositions:' + eventName, payload || {});
                }
                catch (error) {
                    // Ignore diagnostics failures.
                }
            },
            summarizeJobPositions(jobPositions) {
                if (!Array.isArray(jobPositions)) {
                    return { count: 0, first: [] };
                }
                var self = this;
                return {
                    count: jobPositions.length,
                    first: jobPositions.slice(0, 5).map(function (p) {
                        return {
                            id: self.jobPositionId(p),
                            name: self.jobPositionDisplayName(p),
                        };
                    }),
                };
            },
            async workPositionUpdated(updatedList) {
                this.loading++;
                try {
                    var jobPositions = updatedList;
                    if (!Array.isArray(jobPositions) || jobPositions.length === 0) {
                        jobPositions = await WorkOrganisationService.getJobPositions();
                    }
                    this.debugWorkOrganisationFlow('workPositionUpdated', this.summarizeJobPositions(jobPositions));
                    this.setJobPositions(jobPositions);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            modifyJobPosition(item) {
                this.loading++;
                this.workpositiondialog.open(item);
                this.loading--;
            },
            async deleteJobPosition(id) {
                if (confirm(" Är du säker att du vill radera befattningen?")) {
                    this.loading++;
                    try {
                        var jobPositions = await WorkOrganisationService.deleteJobPosition(id);
                        this.displaySnackBar("Borttaget");
                        this.setJobPositions(jobPositions);
                    }
                    catch (error) {
                        this.displayErrorSnackBar(this.getErrorMessage(error, "Ett oväntat fel har inträffat"))
                    }
                    this.loading--;
                }
            },
            async addJobPosition() {
                var result = await this.form.validate();
                if (result.valid != true)
                    return;

                this.loading++;
                try {
                    var nameToCreate = (this.jobPositionName || "").trim();
                    this.debugWorkOrganisationFlow('addJobPosition:start', { name: nameToCreate });
                    var jobPositions = await WorkOrganisationService.addJobPosition(this.jobPositionName);
                    this.displaySnackBar("Sparad");
                    this.setJobPositions(jobPositions);
                    var self = this;
                    var created = jobPositions.find(function (p) {
                        var id = self.jobPositionId(p);
                        var nm = (self.jobPositionDisplayName(p) || "").trim();
                        return p && id > 0 && nm === nameToCreate;
                    });
                    if (!created && jobPositions.length > 0) {
                        created = jobPositions.reduce(function (best, p) {
                            var id = self.jobPositionId(p);
                            if (!p || !id || id <= 0) {
                                return best;
                            }
                            var bestId = best ? self.jobPositionId(best) : 0;
                            if (!best || id > bestId) {
                                return p;
                            }
                            return best;
                        }, null);
                    }
                    var createdId = created ? self.jobPositionId(created) : null;
                    this.debugWorkOrganisationFlow('addJobPosition:response', {
                        requestedName: nameToCreate,
                        createdId: createdId,
                        createdName: created ? self.jobPositionDisplayName(created) : null,
                        jobPositions: this.summarizeJobPositions(jobPositions),
                    });
                    if (created && createdId > 0) {
                        this.$emit("positionSelected", createdId);
                        this.$emit("position-selected", createdId);
                    }
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            setJobPositions(jobPositions) {
                this.internalModel.JobPositions = jobPositions;
                this.debugWorkOrganisationFlow('setJobPositions', this.summarizeJobPositions(jobPositions));
                this.$emit("jobPositionsChanged", jobPositions);
                this.$emit("job-positions-changed", jobPositions);
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
            getErrorMessage(error, fallbackMessage) {
                return error?.response?.data?.message || error?.data?.message || fallbackMessage;
            },
        },

        data() {
            return {
                rules: ValidationService.rules(),
                internalModel:{
                    JobPositions: [],
                    JobTaskSuggestions: [],
                },
                jobPositionTasks: [],
                jobPositionBlocks: [],
                jobPositionName: '',
                jobBlockName: '',
                jobBlockNumber: -1,
                enableRegulation: false,
                newWindow: {},
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        mounted() {
            this.internalModel = this.model;
        },
        setup() {
            return { workpositiondialog, form }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .large-button {
        text-align: center;
        display: grid;
        align-items: center;
        width: 130px;
        min-height: 90px;
        background-color: #4B6FB2;
        color: white;
        cursor: pointer;
        font-size: 15px;
    }

        .large-button.selected {
            background-color: #6C85C0 !important;
        }

    .input {
        border: none;
        border-bottom: 1px solid #ccc;
    }

    .drop {
        color: black;
        text-decoration: none;
        font-size: 20px;
        display: block;
        line-height: 0px;
        margin-top: 5px;
    }

    .tab-title {
        background-color: #4B6FB2;
        color: white;
    }
</style>
